'use client';

import { GlobalSiteHeaderContextProvider } from '@components/GlobalSiteHeader/GlobalSiteHeaderContext';
import GlobalStyle from '@components/Layout/GlobalStyle';
import { SnackbarProvider } from '@components/Snackbar';
import { TypeShopGroupHomepage } from '@contentful/types/TypeShopGroupHomepage';
import { TypeShopHomepage } from '@contentful/types/TypeShopHomepage';
import muiTheme from '@design/mui-theme';
import theme from '@design/theme';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { AbstractGeoResponse } from '@util/types';
import { ConfigProvider, ConfigProviderProps } from 'antd';
import { RootStoreProvider } from 'mobx/RootStoreContext';
import { Shop, ShopGroup } from 'mobx/stores/shop-store';
import { FC, ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

const antdConfig: ConfigProviderProps = {
  theme: {
    token: {
      colorPrimary: '#e60000',
    },
  },
};

interface ProvidersProps {
  shop: Shop | null;
  shopGroup: ShopGroup | null;
  shopSlug: string | null;
  geoInfo?: AbstractGeoResponse | null;
  pageData: TypeShopHomepage | TypeShopGroupHomepage | null;
  children: ReactNode;
}

const Providers: FC<ProvidersProps> = ({
  shop,
  shopGroup,
  shopSlug,
  pageData,
  geoInfo,
  children,
}) => {
  return (
    <RootStoreProvider
      initState={(store) => {
        store.shopStore.setShopPageData(pageData);

        if (shopSlug) {
          store.shopStore.setShopSlug(shopSlug);
        }

        if (shop) {
          store.shopStore.setShop(shop);
        } else if (shopGroup) {
          store.shopStore.setShopGroup(shopGroup);
        }

        if (geoInfo) {
          store.appStore.setGeoInfo(geoInfo);
        }

        store.init();
      }}
    >
      <GlobalSiteHeaderContextProvider>
        <SnackbarProvider>
          <MuiThemeProvider theme={muiTheme}>
            <ThemeProvider theme={theme}>
              <GlobalStyle />
              <ConfigProvider {...antdConfig}>{children}</ConfigProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </SnackbarProvider>
      </GlobalSiteHeaderContextProvider>
    </RootStoreProvider>
  );
};

export default Providers;
